export default __webpack_public_path__ + "static/assets/med_spheric_solid_02_mask.a3a2bf89.png";